import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { API_BASE_URL } from 'utils/axios';

const Tool1RedirectPage = () => {
  const location = useLocation();

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const token = params.get('t');

    if (token) {
      const targetUrl = `${API_BASE_URL}/t/${encodeURIComponent(token)}`;
      window.location.replace(targetUrl);
    }
  }, [location.search]);

  return null;
};

export default Tool1RedirectPage;


